import { ChannelGroupTypes } from '../../types/landing-page';
import { sortChannels } from '../../utils/channels-search';
import { getAllChannels as getAllChannelsUtilFn } from '../../utils/landing-page';
import { CHANNEL_GROUP } from '../defaults/landing-page';
import { RootState } from '../reducers';
import { createMemoizedSelector } from '../selectors';

export function getChannelGroups({ landingPage }: RootState) {
  return landingPage.channelGroups;
}

const createChannelsSelector = (type: ChannelGroupTypes) =>
  createMemoizedSelector(
    [getChannelGroups],
    channelGroups => channelGroups.find(cg => cg.type === type) || CHANNEL_GROUP,
  );

export const getAllChannels = createMemoizedSelector([getChannelGroups], cgs =>
  getAllChannelsUtilFn(cgs).sort(sortChannels),
);

export const getCallOutChannels = createChannelsSelector(ChannelGroupTypes.CALLOUT);

export const getBaseChannels = createChannelsSelector(ChannelGroupTypes.CORE);

export const getAddOnChannels = createChannelsSelector(ChannelGroupTypes.ADDONS);

export const getFreeChannels = createChannelsSelector(ChannelGroupTypes.FAST);

export function getChannelGenreGroups({ landingPage }: RootState) {
  return landingPage.channelGenreGroups;
}

export function getIsBundlePlusEnabled({ landingPage }: RootState) {
  return landingPage.isBundlePlusEnabled;
}

export function getLandingPageDataLoaded({ landingPage }: RootState) {
  return landingPage.landingPageDataLoaded;
}

export function getIsLoadingLandingPageData({ landingPage }: RootState) {
  return landingPage.isLoadingLandingPageData;
}
